module.exports = "<div>\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>"